export const useNavigate = () => {
  const embedded = typeof window !== 'undefined' && window.self !== window.top;

  const navigate = embedded
    ? (path) => window.open(path)
    : (path) => window.location.assign(path);

  return navigate;
};
